module.exports = __webpack_public_path__ + "static/media/arrow-back.329e36c1.svg";